// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.store-header {
  background: var(--cms-header-bg-color);
  padding: 1rem;
  position: sticky;
  top: 0;
  z-index: 10;
}

.store-header-inner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  max-width: 100%;
}

.store-header-text {
  flex: 1;
  min-width: 0;
}

p.store-header-greeting {
  margin: 0 0 0 0.5rem;
  font-size: 0.9rem !important;
  font-weight: 400;
  color: var(--cms-header-text-color);
}

.store-header-menu-btn {
  flex-shrink: 0;
  width: 48px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 0;
  -webkit-tap-highlight-color: transparent;
  color: var(--cms-header-icon-color);
}
.store-header-menu-btn ion-icon {
  font-size: 1.75rem;
}

.store-dropdown-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.4);
  z-index: 100;
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.2s ease, visibility 0.2s ease;
}
.store-dropdown-overlay.store-dropdown-open {
  opacity: 1;
  visibility: visible;
}

.store-dropdown-panel {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  width: min(280px, 85vw);
  max-width: 100%;
  background: var(--cms-header-bg-color);
  color: var(--cms-header-text-color);
  padding: 1.5rem 1rem;
  box-shadow: -4px 0 20px rgba(0, 0, 0, 0.3);
  display: flex;
  flex-direction: column;
  align-items: stretch;
}

.store-dropdown-close {
  align-self: flex-end;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  border: none;
  color: var(--cms-header-icon-color);
  cursor: pointer;
  padding: 0;
  margin-bottom: 0.5rem;
  -webkit-tap-highlight-color: transparent;
}
.store-dropdown-close ion-icon {
  font-size: 1.5rem;
}

.store-dropdown-nav {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 0.25rem;
}

.store-dropdown-item {
  display: block;
  width: 100%;
  padding: 0.875rem 1rem;
  text-align: left;
  font-size: 1rem;
  font-weight: 500;
  color: var(--cms-header-text-color);
  background: transparent;
  border: none;
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
  border-radius: 8px;
}
.store-dropdown-item:hover, .store-dropdown-item:focus {
  background: rgba(0, 0, 0, 0.08);
}`, "",{"version":3,"sources":["webpack://./src/app/components/store-header/store-header.component.scss"],"names":[],"mappings":"AAAA;EACE,sCAAA;EACA,aAAA;EACA,gBAAA;EACA,MAAA;EACA,WAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,eAAA;AACF;;AAEA;EACE,OAAA;EACA,YAAA;AACF;;AAGA;EACE,oBAAA;EACA,4BAAA;EACA,gBAAA;EACA,mCAAA;AAAF;;AAGA;EACE,cAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,uBAAA;EACA,YAAA;EACA,eAAA;EACA,UAAA;EACA,wCAAA;EACA,mCAAA;AAAF;AAEE;EACE,kBAAA;AAAJ;;AAIA;EACE,eAAA;EACA,QAAA;EACA,8BAAA;EACA,YAAA;EACA,UAAA;EACA,kBAAA;EACA,mDAAA;AADF;AAGE;EACE,UAAA;EACA,mBAAA;AADJ;;AAKA;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,uBAAA;EACA,eAAA;EACA,sCAAA;EACA,mCAAA;EACA,oBAAA;EACA,0CAAA;EACA,aAAA;EACA,sBAAA;EACA,oBAAA;AAFF;;AAKA;EACE,oBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,uBAAA;EACA,YAAA;EACA,mCAAA;EACA,eAAA;EACA,UAAA;EACA,qBAAA;EACA,wCAAA;AAFF;AAIE;EACE,iBAAA;AAFJ;;AAMA;EACE,aAAA;EACA,sBAAA;EACA,oBAAA;EACA,YAAA;AAHF;;AAMA;EACE,cAAA;EACA,WAAA;EACA,sBAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,mCAAA;EACA,uBAAA;EACA,YAAA;EACA,eAAA;EACA,wCAAA;EACA,kBAAA;AAHF;AAKE;EAEE,+BAAA;AAJJ","sourcesContent":[".store-header {\n  background: var(--cms-header-bg-color);\n  padding: 1rem;\n  position: sticky;\n  top: 0;\n  z-index: 10;\n}\n\n.store-header-inner {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  max-width: 100%;\n}\n\n.store-header-text {\n  flex: 1;\n  min-width: 0;\n}\n\n\np.store-header-greeting {\n  margin: 0 0 0 0.5rem;\n  font-size: 0.9rem !important;\n  font-weight: 400;\n  color: var(--cms-header-text-color);\n}\n\n.store-header-menu-btn {\n  flex-shrink: 0;\n  width: 48px;\n  height: 48px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: transparent;\n  border: none;\n  cursor: pointer;\n  padding: 0;\n  -webkit-tap-highlight-color: transparent;\n  color: var(--cms-header-icon-color);\n\n  ion-icon {\n    font-size: 1.75rem;\n  }\n}\n\n.store-dropdown-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.4);\n  z-index: 100;\n  opacity: 0;\n  visibility: hidden;\n  transition: opacity 0.2s ease, visibility 0.2s ease;\n\n  &.store-dropdown-open {\n    opacity: 1;\n    visibility: visible;\n  }\n}\n\n.store-dropdown-panel {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  width: min(280px, 85vw);\n  max-width: 100%;\n  background: var(--cms-header-bg-color);\n  color: var(--cms-header-text-color);\n  padding: 1.5rem 1rem;\n  box-shadow: -4px 0 20px rgba(0, 0, 0, 0.3);\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n}\n\n.store-dropdown-close {\n  align-self: flex-end;\n  width: 40px;\n  height: 40px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: transparent;\n  border: none;\n  color: var(--cms-header-icon-color);\n  cursor: pointer;\n  padding: 0;\n  margin-bottom: 0.5rem;\n  -webkit-tap-highlight-color: transparent;\n\n  ion-icon {\n    font-size: 1.5rem;\n  }\n}\n\n.store-dropdown-nav {\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  gap: 0.25rem;\n}\n\n.store-dropdown-item {\n  display: block;\n  width: 100%;\n  padding: 0.875rem 1rem;\n  text-align: left;\n  font-size: 1rem;\n  font-weight: 500;\n  color: var(--cms-header-text-color);\n  background: transparent;\n  border: none;\n  cursor: pointer;\n  -webkit-tap-highlight-color: transparent;\n  border-radius: 8px;\n\n  &:hover,\n  &:focus {\n    background: rgba(0, 0, 0, 0.08);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
